import cn from '@/lib/util/cn'
import { ImSpinner8 } from 'react-icons/im'

const Spinner = ({ className }: { className?: string }) =>
  <ImSpinner8 className={cn('h-4 w-4 animate-spin', className)} />


export default Spinner
